import { render } from "./AccountNextSteps.vue?vue&type=template&id=dd943e1e"
import script from "./AccountNextSteps.vue?vue&type=script&lang=js"
export * from "./AccountNextSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__